import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVisitSuccessMetricsData } from "../../../../redux/prospect-reducers/prospectSlice";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import Modal from "react-modal";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";

const VisitSuccessMetrics = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { visitSuccessMetrics, visitSuccessMetricsLoading } = useSelector((state) => state?.prospects);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modData, setModData] = useState(null);

  const isAdmin = userInfoData?.account_type === "admin";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  useEffect(() => {
    if (userInfoData?.token) {
      const filters = {};
      if (userInfoData?.gym_id && !isAdmin && !isMarketing && !isClusterManager) {
        filters.gym_id = userInfoData.gym_id;
      }
      dispatch(
        fetchVisitSuccessMetricsData({
          filters: filters,
          token: userInfoData?.token,
        })
      );
    }
  }, [dispatch, userInfoData?.token, userInfoData?.gym_id, isAdmin, isMarketing, isClusterManager]);

  const getMetricColorClass = (color) => {
    switch (color) {
      case "green":
        return "metric-green";
      case "blue":
        return "metric-blue";
      case "purple":
        return "metric-purple";
      default:
        return "metric-default";
    }
  };

  const handleMetricClick = (metric) => {
    setModData(metric);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // Reset data after modal close animation completes
    setTimeout(() => {
      setModData(null);
    }, 300);
  };

  const metricsData = visitSuccessMetrics?.data?.[0];

  // Create metrics array for rendering
  const metrics = [
    {
      label: "Visits Scheduled",
      value: metricsData?.visits_scheduled || "0",
      color: "default",
      description: "Total number of visits scheduled",
      key: "visits_scheduled"
    },
    {
      label: "Visits Completed", 
      value: metricsData?.visits_completed || "0",
      color: "default",
      description: "Total number of visits completed",
      key: "visits_completed"
    },
    {
      label: "Visit Show Rate",
      value: metricsData?.visit_show_rate ? `${metricsData.visit_show_rate}%` : "0%",
      color: "green",
      description: "Percentage of scheduled visits that were completed",
      key: "visit_show_rate"
    },
    {
      label: "Visit to Closure Expected",
      value: metricsData?.visit_to_closure_expected || "0",
      color: "blue", 
      description: "Expected closures from visits",
      key: "visit_to_closure_expected"
    },
    {
      label: "Visit Conversion Rate",
      value: metricsData?.visit_conversion_rate ? `${metricsData.visit_conversion_rate}%` : "0%",
      color: "purple",
      description: "Rate of visits converted to closures",
      key: "visit_conversion_rate"
    }
  ];

  return (
    <div className="lms-closure-visit-metrics-card">
      <div className="lms-closure-visit-metrics-header">
        <h3 className="lms-closure-visit-metrics-title">Visit Success Metrics</h3>
        <p className="lms-closure-visit-metrics-subtitle">Gym visit conversion performance</p>
      </div>
      <div className="lms-closure-visit-metrics-body">
        <div className="lms-closure-visit-metrics-items">
          {visitSuccessMetricsLoading ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 120 }}>
              <ReactVortoxSpinner />
            </div>
          ) : metricsData ? (
            <>
              {metrics.map((metric, index) => (
                <div 
                  key={index} 
                  className="lms-closure-visit-metrics-item clickable-metric"
                  onClick={() => handleMetricClick(metric)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="lms-closure-visit-metrics-label">{metric.label}</span>
                  <span className={`lms-closure-visit-metrics-value ${getMetricColorClass(metric.color)}`}>
                    {metric.value}
                  </span>
                </div>
              ))}
            </>
          ) : (
            <div className="lms-closure-visit-metrics-item">
              <p>No metrics data available</p>
            </div>
          )}
        </div>
      </div>

      {/* Modal for Metric Details */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Visit Success Metric Details Modal"
        ariaHideApp={false}
        closeTimeoutMS={300}
      >
        <div className="modal-body-k small container rounded-4 bg-white">
          <ModalHeadAndClose
            title={modData ? `${modData.label} Details` : "Metric Details"} 
            onClose={handleCloseModal} 
          />
        </div>
      </Modal>
    </div>
  );
};

export default VisitSuccessMetrics; 